import { ConfirmDialog } from "@knowfully/ui.common";
import { Alert } from "@mui/material";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import translateError from "utils/translateError";

type ReactivateUserDialogProps = {
  organizationUserId?: string;
  close: () => void;
};

export default function ReactivateUserDialog({
  organizationUserId,
  close,
}: ReactivateUserDialogProps) {
  const { formatMessage: t } = useIntl();
  const { organizationUserService } = useGlobalContext();
  const queryClient = useQueryClient();

  const submit = async () => {
    try {
      await organizationUserService.reactivateUser(organizationUserId!);
      queryClient.invalidateQueries(["organizationUserService.getUsers"]);
      close();
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  const content = (
    <Alert severity="info">
      <T id="youAreAboutToReactivateUser" />
      <br />
      <br />
      <T id="immediatelyGrantAccessLevel" />
    </Alert>
  );

  return (
    <ConfirmDialog
      title={t({ id: "reactivateUser" })}
      content={content}
      open={!!organizationUserId}
      onSubmit={submit}
      close={close}
    />
  );
}
